"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FromObservable_1 = require("./FromObservable");
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/from.js
// module id = 303
// module chunks = 4